module.exports = __webpack_public_path__ + "images/911857c5.png";